import Api from 'api'

const config = {
  baseURL: '/api/app/v2',
}

const api = new Api(config)

api.fetchAll = ({ networkType, ...rest }) =>
  api.get(`/${networkType}/recommendations`, { ...rest })
api.fetchType = ({ networkType, type, ...rest }) =>
  api.get(`/${networkType}/recommendations/${type}`, { ...rest })

export default api
